import { LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon } from "geojson"

// There's no option for an individual geometry in the geojson types
export type SingleGeometry = Point | MultiPoint | LineString | MultiLineString | Polygon | MultiPolygon

export interface GeometryWithStatus {
    selected: boolean
    status: GeometryReviewStatus
    geometry: SingleGeometry
}

export enum GeometryReviewStatus {
    ACCEPTED = "ACCEPTED",
    CONDITIONALLY_ACCEPTED = "CONDITIONALLY_ACCEPTED",
    UNDER_REVIEW = "UNDER_REVIEW",
    REFLY_REQUIRED = "REFLY_REQUIRED",
    NOT_ACQUIRED = "NOT_ACQUIRED",
}

export const geometryReviewStatusProperties = (status: GeometryReviewStatus): { color: string } => {
    switch (status) {
        case GeometryReviewStatus.ACCEPTED:
            return { color: "#1410FE" }
        case GeometryReviewStatus.CONDITIONALLY_ACCEPTED:
            return { color: "#7A009C" }
        case GeometryReviewStatus.NOT_ACQUIRED:
            return { color: "#F0E442" }
        case GeometryReviewStatus.REFLY_REQUIRED:
            return { color: "#E69F1B" }
        case GeometryReviewStatus.UNDER_REVIEW:
            return { color: "#FF10FD" }
        default:
            throw new Error(`Unknown geometry review status: ${status}`)
    }
}
